module.exports = __webpack_public_path__ + "static/media/add talent category.9999d1f3.svg";